import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { resetDataCorporateFailure, resetDataCorporateRequest, resetDataCorporateSuccess } from "../slice/resetCorporateSlice";
import { config } from "../../../config/global";

// API Post URL for Reset Password
const Reset_API_URL = config.UNLOCK_ACCOUNT_CORPORATE_API;
const fetchResetDataCorporate = async resetPayload => {
  const data = {
    mode: "no-cors",
    headers: {
      "content-type": "application/json"
    }
  };
  const response = await api.post(Reset_API_URL, resetPayload, data);
  return response;
};

// Get data generator function
function* getResetCorporate(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchResetDataCorporate, payload);
    yield put(resetDataCorporateSuccess(response.data));
  } catch (error) {
    yield put(resetDataCorporateFailure(error.response.data));
  }
}
export function* watchCorporateReset() {
  yield takeLatest(resetDataCorporateRequest.type, getResetCorporate);
}